var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._v("新建用户")]),_c('div',{staticClass:"wrap"},[_c('user-info',{attrs:{"groups":_vm.groups}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }